import type { CappusErrorContext } from './cappus-error-context';
import { HttpContextToken } from '@angular/common/http';

export const ERROR_CONTEXT = new HttpContextToken<CappusErrorContext>(() => ({
  skipGlobalHandlers: false,
}));
